module.exports = __webpack_public_path__ + "media/images/icons/ic-dropdown-arrow-3713aaa3639e058dad269da7f88a612b.svg";